<template>
    <div class="share-c" @mouseenter="handleMouseEnter">
        <div class="icon-c">
            <div class="share-icon"></div>
        </div>
        <div class="count">分享</div>
        <div class="share-icons-c">
            <div class="share-icons">
                <div class="weixin">
                    <a href="javascript:void(0)" ref="wxRef">
                        <em class="icon weixin-icon"></em><span class="label">微信好友</span>
                    </a>
                    <div id="qrcode" class="qrcode"></div>
                </div>
                <div class="item sinat">
                    <a data-clev="10220259" target="_blank" :href="sina_url" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:weibo">
                        <em class="icon sinat-icon"></em>
                        <span class="label">新浪微博</span>
                    </a>
                </div>
                <div class="item qzone">
                    <a data-clev="10220260" target="_blank" :href="qzone_url" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:qqz">
                        <em class="icon qzone-icon"></em>
                        <span class="label"></span>QQ空间
                    </a>
                </div>
                <div class="item copy-link" @click="copy" @mouseenter.once="copy">
                    <a href="javascript:void(0)" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:link">
                        <em class="icon link-icon"></em><span class="label">复制链接</span>
                    </a>
                </div>
                <div class="toast" v-show="showToast">
                    <div class="toast-text">链接复制成功</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from "@/utils/Utils"
import QRCode from 'qrcodejs2'
import { env } from '@/env'
import { acodeConfig } from '@/config/spmConfig'

export default {
    components: {
    },
    data() {
        return {
            url: window.location.href,
            title: '',
            pic: '',
            qzone_url: '',
            sina_url: '',
            showToast: false,
            qrcodeUrl: '',
            shareAction: acodeConfig.shareAction
        }
    },
    mounted() {
        const articleinfo = window?.pcArticleInfo
        this.pic = document.querySelector('article img')?.src || ''
        this.title = articleinfo?.title
        this.qrcodeUrl = '/a/' + articleinfo?.news_id + '_' + articleinfo?.media_id
        this.sina_url = "http://service.weibo.com/share/share.php?url=" + encodeURIComponent(this.url) + "&title=" + encodeURIComponent(this.title) + "&searchPic=true&pic=" + this.pic+"&appkey=2890110694";
        this.getQzoneUrl()
        this.renderCode()
        this.addBreath()
    },
    methods: {
        // 增加微信呼吸特效
        addBreath() {
            this.$nextTick(()=>{
                var shareEle = document.querySelector('.icon-c .share-icon')
                if(shareEle){
                    this.timeOutFunc(5000).then(()=>{
                        shareEle.style.transition = " all ease-in-out 0.6s "
                        shareEle.style.background = "url(https://statics.itc.cn/mptc-mpfe/img/article/icon_wechat3.png)"
                        shareEle.style.backgroundSize = "contain"
                        var internalId = setInterval(()=>{
                            shareEle.style.transform = "scale(1.3)";
                            var timeOut = setTimeout(()=>{
                                shareEle.style.transform = "scale(1)";
                                clearTimeout(timeOut)
                            },600)
                        },1200)
                        var shutDown = setTimeout(() => {
                            clearInterval(internalId)
                            clearTimeout(shutDown)
                            shareEle.style.transform = "none";
                            shareEle.style.removeProperty('background')
                            shareEle.style.removeProperty('backgroundSize')
                            shareEle.style.removeProperty('transition')
                        }, 4800); // 关闭呼吸效果，清除定时器
                    })
                }
            })
        },
        timeOutFunc(delay = 1000){
            return new Promise(resolve => setTimeout(resolve, delay));
        },
        getQzoneUrl() {
            let prod_qzone_url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(this.url);
            let test_qzone_url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(this.url) + "&title=" + encodeURIComponent(this.title) + "&searchPic=true&pics=" + this.pic + "?imageView&thumbnail=550x0&desc=";
            this.qzone_url = env == 'prod' ? prod_qzone_url : test_qzone_url
        },
        copy() {
            import(/* webpackChunkName: "clipboard" */'clipboard').then((Clipboard)=>{
                let copylink = Utils.getWapSohuHost() + this.qrcodeUrl + '?_trans_=010004_pcwzy';

                var clipboard = new Clipboard.default('.copy-link', {
                    text: () => window?.pcArticleInfo?.title + " - 搜狐网" + "\n" + copylink
                });
                clipboard.on('success', () => {
                    this.showToast = true
                    var timer = setTimeout(() => {
                        this.showToast = false
                        clearTimeout(timer)
                    }, 2000)
                    clipboard.destroy(); // 复制成功后销毁实例
                });
                clipboard.on('error', () => {
                    console.error('复制链接失败');
                    clipboard.destroy(); // 复制失败后销毁实例
                });
            })
        },
        renderCode() {
            this.$refs['wxRef']?.addEventListener('mouseenter',()=>{
                window?.sohuSpm?.sendAction({
                     acode: acodeConfig.shareAction,
                     clkParam: 'shareCode:wxf'
                })
            })
            new QRCode(document.querySelector('.qrcode'), {
                text: Utils.getWapSohuHost() + this.qrcodeUrl + '?_trans_=010005_pcwzyswxmdkfx', // 需要转换为二维码的内容
                width:77,
                height: 77,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        handleMouseEnter() {
            window.sohuSpm?.sendAction({acode: 11094})
        }
    }
}
</script>
<style lang="less" scoped>
    .share-c {
        cursor: pointer;
        position: relative;
        .icon-c {
            width: 48px;
            height: 48px;
            background: #F8F8F8;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .share-icon {
                width: 22px;
                height: 22px;
                display: block;
                background: url('../../images/icon_share@2x.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
        .count {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #111111;
            line-height: 17px;
            text-align: left;
            font-style: normal;
            margin-top: 4px;
            text-align: center;
        }
        .share-icons-c {
            display: none;
            position: absolute;
            z-index: 1;
            left: 39px;
            top: -60px;
            width: 156px;
            height: 295px;
            background: url('../../images/share-bg.png');
            background-size: 100% 100%;
            .share-icons {
                position: absolute;
                left: 24px;
                top: 10px;
                width: 118px;
                box-sizing: border-box;
                .item{
                    width: 110px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    justify-content: center;
                    margin-left: 3px;
                a {
                    flex: 1;
                    color:#333;
                    box-sizing:border-box;
                    display: block;
                    line-height: 42px;
                    display: flex;
                    align-items: center;
                    padding-left: 8px;

                }
                .icon {
                    margin-right:10px;
                    width:20px;
                    height:20px;
                }
                .sinat-icon{
                    background:url(../../images/ic_Weibo.png) no-repeat 0 0;
                    background-size: 100% 100%;
                }
                .qzone-icon{
                    background:url(../../images/ic_Qzone.png) no-repeat 0 0;
                    background-size: 100% 100%;
                }
                .link-icon{
                    background:url('../../images/link-pc.png') no-repeat 0 0;
                    background-size: 100% 100%;
                }
            }
            .item:hover{
                background: #f8f8f8;
            }

            .weixin{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-bottom: 1px solid #EFEFEF;
                padding-bottom: 12px;
                margin-left: 8px;
                margin-right: 8px;
                a {
                    flex: 1;
                    color:#333;
                    box-sizing:border-box;
                    display: block;
                    line-height: 42px;
                    display: flex;
                    align-items: center;
                }
                .icon {
                    margin-right:10px;
                    width:20px;
                    height:20px;
                }
                .weixin-icon{
                    background:url(../../images/ic_WeChat.png) no-repeat 0 0;
                    background-size: 100% 100%;
                }
            }
            .toast {
                position: fixed;
                width: 1180px;
                margin: 0 auto;
                z-index: 999;
                top: 80px;
            .toast-text {
                margin-left:190px;
                width: 600px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #ffffff;
                color: #303030;
                box-shadow: 3px 3px 10px rgba(0,0,0,.12);
            }
        }
            }
        }
    }
    .share-c:hover {
        .share-icons-c {
            display: block;
        }
        .icon-c {
            background: #f6f6f6;
        }
    }

</style>